import sortBy from 'lodash/sortBy';
import type {VerifiedLinkedCatalogPost} from 'schemaDefinition/types';
import {isNullish} from 'schemaDefinition/functions';

export const sortCollectionLinks = (
  links: VerifiedLinkedCatalogPost[],
): VerifiedLinkedCatalogPost[] => {
  const hasNumber = (link: VerifiedLinkedCatalogPost) =>
    !isNullish(link.numberInSeries) && link.numberInSeries.length > 0;
  const numberedLinks = links.filter(l => hasNumber(l));
  const unnumberedLinks = links.filter(l => !hasNumber(l));

  const descByNameNumbered = sortBy(numberedLinks, l =>
    l.link.name.toLowerCase(),
  ).reverse();
  // Desc by number/range, then asc by name
  const digitsRegex = /^\d+/;
  const rangeRegex = /^\d+-\d+/;
  const descNumbered = sortBy(descByNameNumbered, l =>
    rangeRegex.test(l.numberInSeries ?? '')
      ? parseFloat((l.numberInSeries ?? '0').replace('-', '.'))
      : digitsRegex.test(l.numberInSeries ?? '')
        ? parseInt(l.numberInSeries ?? '0')
        : l.numberInSeries,
  ).reverse();

  const ascUnnumbered = sortBy(unnumberedLinks, l => l.link.name.toLowerCase());

  return [...descNumbered, ...ascUnnumbered];
};
